var items = {
  "block.minecraft.air": "loft",
  "block.minecraft.stone": "stone",
  "block.minecraft.granite": "moorstone",
  "block.minecraft.polished_granite": "smooth moorstone",
  "block.minecraft.diorite": "markfieldstone",
  "block.minecraft.polished_diorite": "smooth markfieldstone",
  "block.minecraft.andesite": "andestone",
  "block.minecraft.polished_andesite": "smooth andestone",
  "block.minecraft.grass_block": "grass cleat",
  "block.minecraft.dirt": "earth",
  "block.minecraft.coarse_dirt": "rough earth",
  "block.minecraft.podzol": "underash",
  "block.minecraft.crimson_nylium": "base nemb earth",
  "block.minecraft.warped_nylium": "warped nemb earth",
  "block.minecraft.cobblestone": "cobblestone",
  "block.minecraft.oak_planks": "oak boards",
  "block.minecraft.spruce_planks": "harttartree boards",
  "block.minecraft.birch_planks": "birch boards",
  "block.minecraft.jungle_planks": "rainwold boards",
  "block.minecraft.acacia_planks": "wattletree boards",
  "block.minecraft.dark_oak_planks": "dark oak boards",
  "block.minecraft.crimson_planks": "base boards",
  "block.minecraft.warped_planks": "warped boards",
  "block.minecraft.oak_sapling": "oak sapling",
  "block.minecraft.spruce_sapling": "harttartree sapling",
  "block.minecraft.birch_sapling": "birch sapling",
  "block.minecraft.jungle_sapling": "rainwold sapling",
  "block.minecraft.acacia_sapling": "wattletree sapling",
  "block.minecraft.dark_oak_sapling": "dark oak sapling",
  "block.minecraft.bedrock": "bedstone",
  "block.minecraft.sand": "sand",
  "block.minecraft.red_sand": "red sand",
  "block.minecraft.gravel": "pebbles",
  "block.minecraft.gold_ore": "gold ore",
  "block.minecraft.iron_ore": "iron ore",
  "block.minecraft.coal_ore": "coal ore",
  "block.minecraft.nether_gold_ore": "nether gold ore",
  "block.minecraft.oak_log": "oak woodstem",
  "block.minecraft.spruce_log": "harttartree woodstem",
  "block.minecraft.birch_log": "birch woodstem",
  "block.minecraft.jungle_log": "rainwold woodstem",
  "block.minecraft.acacia_log": "wattletree woodstem",
  "block.minecraft.dark_oak_log": "dark oak woodstem",
  "block.minecraft.crimson_stem": "base stem",
  "block.minecraft.warped_stem": "warped stem",
  "block.minecraft.stripped_oak_log": "stripped oak woodstem",
  "block.minecraft.stripped_spruce_log": "stripped harttartree woodstem",
  "block.minecraft.stripped_birch_log": "stripped birch woodstem",
  "block.minecraft.stripped_jungle_log": "stripped rainwold woodstem",
  "block.minecraft.stripped_acacia_log": "stripped wattletree woodstem",
  "block.minecraft.stripped_dark_oak_log": "stripped dark oak woodstem",
  "block.minecraft.stripped_crimson_stem": "stripped base stem",
  "block.minecraft.stripped_warped_stem": "stripped warped stem",
  "block.minecraft.stripped_oak_wood": "stripped oak wood",
  "block.minecraft.stripped_spruce_wood": "stripped harttartree wood",
  "block.minecraft.stripped_birch_wood": "stripped birch wood",
  "block.minecraft.stripped_jungle_wood": "stripped rainwold wood",
  "block.minecraft.stripped_acacia_wood": "stripped wattletree wood",
  "block.minecraft.stripped_dark_oak_wood": "stripped dark oak wood",
  "block.minecraft.stripped_crimson_hyphae": "stripped base swambwood",
  "block.minecraft.stripped_warped_hyphae": "stripped warped swambwood",
  "block.minecraft.oak_wood": "oak wood",
  "block.minecraft.spruce_wood": "harttartree wood",
  "block.minecraft.birch_wood": "birch wood",
  "block.minecraft.jungle_wood": "rainwold wood",
  "block.minecraft.acacia_wood": "wattletree wood",
  "block.minecraft.dark_oak_wood": "dark oak wood",
  "block.minecraft.crimson_hyphae": "base swambwood",
  "block.minecraft.warped_hyphae": "warped swambwood",
  "block.minecraft.oak_leaves": "oak leaves",
  "block.minecraft.spruce_leaves": "harttartree leaves",
  "block.minecraft.birch_leaves": "birch leaves",
  "block.minecraft.jungle_leaves": "rainwold leaves",
  "block.minecraft.acacia_leaves": "wattletree leaves",
  "block.minecraft.dark_oak_leaves": "dark oak leaves",
  "block.minecraft.sponge": "soakshaft",
  "block.minecraft.wet_sponge": "wet soakshaft",
  "block.minecraft.glass": "glass",
  "block.minecraft.lapis_ore": "hewenstone ore",
  "block.minecraft.lapis_block": "hewenstone cleat",
  "block.minecraft.dispenser": "thrower",
  "block.minecraft.sandstone": "sandstone",
  "block.minecraft.chiseled_sandstone": "graven sandstone",
  "block.minecraft.cut_sandstone": "cut sandstone",
  "block.minecraft.note_block": "ringer",
  "block.minecraft.powered_rail": "livened ironpath",
  "block.minecraft.detector_rail": "acknower ironpath",
  "block.minecraft.sticky_piston": "sticky stampend",
  "block.minecraft.cobweb": "cobweb",
  "block.minecraft.grass": "grass",
  "block.minecraft.fern": "fern",
  "block.minecraft.dead_bush": "dead bush",
  "block.minecraft.seagrass": "seagrass",
  "block.minecraft.sea_pickle": "sea pickle",
  "block.minecraft.piston": "stampend",
  "block.minecraft.white_wool": "white wool",
  "block.minecraft.orange_wool": "yellowred wool",
  "block.minecraft.magenta_wool": "bawsered wool",
  "block.minecraft.light_blue_wool": "light hewen wool",
  "block.minecraft.yellow_wool": "yellow wool",
  "block.minecraft.lime_wool": "light green wool",
  "block.minecraft.pink_wool": "pink wool",
  "block.minecraft.gray_wool": "gray wool",
  "block.minecraft.light_gray_wool": "light gray wool",
  "block.minecraft.cyan_wool": "hewengreen wool",
  "block.minecraft.purple_wool": "bawse wool",
  "block.minecraft.blue_wool": "hewen wool",
  "block.minecraft.brown_wool": "brown wool",
  "block.minecraft.green_wool": "green wool",
  "block.minecraft.red_wool": "red wool",
  "block.minecraft.black_wool": "black wool",
  "block.minecraft.dandelion": "lionstooth",
  "block.minecraft.poppy": "poppy",
  "block.minecraft.blue_orchid": "hewen ballockwort",
  "block.minecraft.allium": "leek",
  "block.minecraft.azure_bluet": "hewenling",
  "block.minecraft.red_tulip": "red houvebloom",
  "block.minecraft.orange_tulip": "yellowred houvebloom",
  "block.minecraft.white_tulip": "white houvebloom",
  "block.minecraft.pink_tulip": "pink houvebloom",
  "block.minecraft.oxeye_daisy": "oxeye daisy",
  "block.minecraft.cornflower": "cornblossom",
  "block.minecraft.lily_of_the_valley": "may bells",
  "block.minecraft.wither_rose": "wither rose",
  "block.minecraft.brown_mushroom": "brown swamb",
  "block.minecraft.red_mushroom": "red swamb",
  "block.minecraft.crimson_fungus": "base fieldswamb",
  "block.minecraft.warped_fungus": "warped fieldswamb",
  "block.minecraft.crimson_roots": "base stems",
  "block.minecraft.warped_roots": "warped stems",
  "block.minecraft.nether_sprouts": "nether sprouts",
  "block.minecraft.weeping_vines": "weeping hanggrass",
  "block.minecraft.twisting_vines": "twisting standgrass",
  "block.minecraft.sugar_cane": "sweet reed",
  "block.minecraft.kelp": "ash seaweed",
  "block.minecraft.bamboo": "treereed",
  "block.minecraft.gold_block": "cleat of gold",
  "block.minecraft.iron_block": "cleat of iron",
  "block.minecraft.oak_slab": "oak slab",
  "block.minecraft.spruce_slab": "harttartree slab",
  "block.minecraft.birch_slab": "birch slab",
  "block.minecraft.jungle_slab": "rainwold slab",
  "block.minecraft.acacia_slab": "wattletree slab",
  "block.minecraft.dark_oak_slab": "dark oak slab",
  "block.minecraft.crimson_slab": "base slab",
  "block.minecraft.warped_slab": "warped slab",
  "block.minecraft.stone_slab": "stone slab",
  "block.minecraft.smooth_stone_slab": "smooth stone slab",
  "block.minecraft.sandstone_slab": "sandstone slab",
  "block.minecraft.cut_sandstone_slab": "cut sandstone slab",
  "block.minecraft.petrified_oak_slab": "stoneledged oak slab",
  "block.minecraft.cobblestone_slab": "cobblestone slab",
  "block.minecraft.brick_slab": "bakestone slab",
  "block.minecraft.stone_brick_slab": "stonestave slab",
  "block.minecraft.nether_brick_slab": "nether bakestone slab",
  "block.minecraft.quartz_slab": "hardstone slab",
  "block.minecraft.red_sandstone_slab": "red sandstone slab",
  "block.minecraft.cut_red_sandstone_slab": "cut red sandstone slab",
  "block.minecraft.purpur_slab": "bawser slab",
  "block.minecraft.prismarine_slab": "shimmereen slab",
  "block.minecraft.prismarine_brick_slab": "shimmereen stonestave slab",
  "block.minecraft.dark_prismarine_slab": "dark shimmereen slab",
  "block.minecraft.smooth_quartz": "smooth hardstone cleat",
  "block.minecraft.smooth_red_sandstone": "smooth red sandstone",
  "block.minecraft.smooth_sandstone": "smooth sandstone",
  "block.minecraft.smooth_stone": "smooth stone",
  "block.minecraft.bricks": "bakestones",
  "block.minecraft.tnt": "blastkeg",
  "block.minecraft.bookshelf": "bookshelf",
  "block.minecraft.mossy_cobblestone": "mossy cobblestone",
  "block.minecraft.obsidian": "ravenglass",
  "block.minecraft.torch": "thackle",
  "block.minecraft.end_rod": "end rod",
  "block.minecraft.chorus_plant": "stal wort",
  "block.minecraft.chorus_flower": "stalbloom",
  "block.minecraft.purpur_block": "bawser cleat",
  "block.minecraft.purpur_pillar": "bawser staple",
  "block.minecraft.purpur_stairs": "bawser stairs",
  "block.minecraft.spawner": "begetter",
  "block.minecraft.oak_stairs": "oak stairs",
  "block.minecraft.chest": "chest",
  "block.minecraft.diamond_ore": "hardhirst ore",
  "block.minecraft.diamond_block": "cleat of hardhirst",
  "block.minecraft.crafting_table": "workbench",
  "block.minecraft.farmland": "farmland",
  "block.minecraft.furnace": "oven",
  "block.minecraft.ladder": "ladder",
  "block.minecraft.rail": "ironpath",
  "block.minecraft.cobblestone_stairs": "cobblestone stairs",
  "block.minecraft.lever": "switch",
  "block.minecraft.stone_pressure_plate": "stone thrutch dish",
  "block.minecraft.oak_pressure_plate": "oak thrutch dish",
  "block.minecraft.spruce_pressure_plate": "harttartree thrutch dish",
  "block.minecraft.birch_pressure_plate": "birch thrutch dish",
  "block.minecraft.jungle_pressure_plate": "rainwold thrutch dish",
  "block.minecraft.acacia_pressure_plate": "wattletree thrutch dish",
  "block.minecraft.dark_oak_pressure_plate": "dark oak thrutch dish",
  "block.minecraft.crimson_pressure_plate": "base thrutch dish",
  "block.minecraft.warped_pressure_plate": "warped thrutch dish",
  "block.minecraft.polished_blackstone_pressure_plate": "smooth blackstone thrutch dish",
  "block.minecraft.redstone_ore": "redstone ore",
  "block.minecraft.redstone_torch": "redstone thackle",
  "block.minecraft.snow": "snow",
  "block.minecraft.ice": "ice",
  "block.minecraft.snow_block": "snow block",
  "block.minecraft.cactus": "thorntree",
  "block.minecraft.clay": "clay",
  "block.minecraft.jukebox": "song crate",
  "block.minecraft.oak_fence": "oak sundering",
  "block.minecraft.spruce_fence": "harttartree sundering",
  "block.minecraft.birch_fence": "birch sundering",
  "block.minecraft.jungle_fence": "rainwold sundering",
  "block.minecraft.acacia_fence": "wattletree sundering",
  "block.minecraft.dark_oak_fence": "dark oak sundering",
  "block.minecraft.crimson_fence": "base sundering",
  "block.minecraft.warped_fence": "warped sundering",
  "block.minecraft.pumpkin": "harvestovet",
  "block.minecraft.carved_pumpkin": "carved harvestovet",
  "block.minecraft.netherrack": "netherharst",
  "block.minecraft.soul_sand": "soul sand",
  "block.minecraft.soul_soil": "soul earth",
  "block.minecraft.basalt": "rinestone",
  "block.minecraft.polished_basalt": "smooth rinestone",
  "block.minecraft.soul_torch": "soul thackle",
  "block.minecraft.glowstone": "glowstone",
  "block.minecraft.jack_o_lantern": "jack o'lightvat",
  "block.minecraft.oak_trapdoor": "oak trapdoor",
  "block.minecraft.spruce_trapdoor": "harttartree trapdoor",
  "block.minecraft.birch_trapdoor": "birch trapdoor",
  "block.minecraft.jungle_trapdoor": "rainwold trapdoor",
  "block.minecraft.acacia_trapdoor": "wattletree trapdoor",
  "block.minecraft.dark_oak_trapdoor": "dark oak trapdoor",
  "block.minecraft.crimson_trapdoor": "base trapdoor",
  "block.minecraft.warped_trapdoor": "warped trapdoor",
  "block.minecraft.infested_stone": "incoathed stone",
  "block.minecraft.infested_cobblestone": "incoathed cobblestone",
  "block.minecraft.infested_stone_bricks": "incoathed stonestaves",
  "block.minecraft.infested_mossy_stone_bricks": "incoathed mossy stonestaves",
  "block.minecraft.infested_cracked_stone_bricks": "incoathed cracked stonestaves",
  "block.minecraft.infested_chiseled_stone_bricks": "incoathed graven stonestaves",
  "block.minecraft.stone_bricks": "stonestaves",
  "block.minecraft.mossy_stone_bricks": "mossy stonestaves",
  "block.minecraft.cracked_stone_bricks": "cracked stonestaves",
  "block.minecraft.chiseled_stone_bricks": "graven stonestaves",
  "block.minecraft.brown_mushroom_block": "brown toadstool steck",
  "block.minecraft.red_mushroom_block": "red toadstool steck",
  "block.minecraft.mushroom_stem": "swamb stem",
  "block.minecraft.iron_bars": "iron rods",
  "block.minecraft.chain": "fetter",
  "block.minecraft.glass_pane": "glass window",
  "block.minecraft.melon": "entapple",
  "block.minecraft.vine": "hanggrass",
  "block.minecraft.oak_fence_gate": "oak gate",
  "block.minecraft.spruce_fence_gate": "harttartree gate",
  "block.minecraft.birch_fence_gate": "birch gate",
  "block.minecraft.jungle_fence_gate": "rainwold gate",
  "block.minecraft.acacia_fence_gate": "wattletree gate",
  "block.minecraft.dark_oak_fence_gate": "dark oak gate",
  "block.minecraft.crimson_fence_gate": "base gate",
  "block.minecraft.warped_fence_gate": "warped gate",
  "block.minecraft.brick_stairs": "bakestone stairs",
  "block.minecraft.stone_brick_stairs": "stonestave stairs",
  "block.minecraft.mycelium": "swamb earth",
  "block.minecraft.lily_pad": "lily pad",
  "block.minecraft.nether_bricks": "nether bakestones",
  "block.minecraft.cracked_nether_bricks": "cracked nether bakestones",
  "block.minecraft.chiseled_nether_bricks": "graven nether bakestones",
  "block.minecraft.nether_brick_fence": "nether bakestone sundering",
  "block.minecraft.nether_brick_stairs": "nether bakestones stairs",
  "block.minecraft.enchanting_table": "galdercraft bench",
  "block.minecraft.end_portal_frame": "end gateway frame",
  "block.minecraft.end_stone": "end stone",
  "block.minecraft.end_stone_bricks": "end stonestaves",
  "block.minecraft.dragon_egg": "wyrm ey",
  "block.minecraft.redstone_lamp": "redstone lightvat",
  "block.minecraft.sandstone_stairs": "sandstone stairs",
  "block.minecraft.emerald_ore": "greenhirst ore",
  "block.minecraft.ender_chest": "ender chest",
  "block.minecraft.tripwire_hook": "tripwire hook",
  "block.minecraft.emerald_block": "cleat of greenhirst",
  "block.minecraft.spruce_stairs": "harttartree stairs",
  "block.minecraft.birch_stairs": "birch stairs",
  "block.minecraft.jungle_stairs": "rainwold stairs",
  "block.minecraft.crimson_stairs": "base stairs",
  "block.minecraft.warped_stairs": "warped stairs",
  "block.minecraft.command_block": "hest block",
  "block.minecraft.beacon": "beacon",
  "block.minecraft.cobblestone_wall": "cobblestone sundercleat",
  "block.minecraft.mossy_cobblestone_wall": "mossy cobblestone sundercleat",
  "block.minecraft.brick_wall": "bakestone sundercleat",
  "block.minecraft.prismarine_wall": "shimmereen sundercleat",
  "block.minecraft.red_sandstone_wall": "red sandstone sundercleat",
  "block.minecraft.mossy_stone_brick_wall": "mossy stonestave sundercleat",
  "block.minecraft.granite_wall": "moorstone sundercleat",
  "block.minecraft.stone_brick_wall": "stonestave sundercleat",
  "block.minecraft.nether_brick_wall": "nether bakestone sundercleat",
  "block.minecraft.andesite_wall": "andestone sundercleat",
  "block.minecraft.red_nether_brick_wall": "red nether bakestone sundercleat",
  "block.minecraft.sandstone_wall": "sandstone sundercleat",
  "block.minecraft.end_stone_brick_wall": "end stonestave sundercleat",
  "block.minecraft.diorite_wall": "markfieldstone sundercleat",
  "block.minecraft.blackstone_wall": "blackstone sundercleat",
  "block.minecraft.polished_blackstone_wall": "smooth blackstone sundercleat",
  "block.minecraft.polished_blackstone_brick_wall": "smooth blackstone stonestave sundercleat",
  "block.minecraft.stone_button": "stone knob",
  "block.minecraft.oak_button": "oak knob",
  "block.minecraft.spruce_button": "harttartree knob",
  "block.minecraft.birch_button": "birch knob",
  "block.minecraft.jungle_button": "rainwold button",
  "block.minecraft.acacia_button": "wattletree knob",
  "block.minecraft.dark_oak_button": "dark oak knob",
  "block.minecraft.crimson_button": "base knob",
  "block.minecraft.warped_button": "warped knob",
  "block.minecraft.polished_blackstone_button": "smooth blackstone knob",
  "block.minecraft.anvil": "anvil",
  "block.minecraft.chipped_anvil": "chipped anvil",
  "block.minecraft.damaged_anvil": "broken anvil",
  "block.minecraft.trapped_chest": "trapped chest",
  "block.minecraft.light_weighted_pressure_plate": "light weighted thrutch dish",
  "block.minecraft.heavy_weighted_pressure_plate": "heavy weighted thrutch dish",
  "block.minecraft.daylight_detector": "daylight anyettend",
  "block.minecraft.redstone_block": "cleat of redstone",
  "block.minecraft.nether_quartz_ore": "nether hardstone ore",
  "block.minecraft.hopper": "hopper",
  "block.minecraft.chiseled_quartz_block": "graven hardstone block",
  "block.minecraft.quartz_block": "block of hardstone",
  "block.minecraft.quartz_bricks": "hardstone bakestones",
  "block.minecraft.quartz_pillar": "hardstone staple",
  "block.minecraft.quartz_stairs": "hardstone stairs",
  "block.minecraft.activator_rail": "astirrend ironpath",
  "block.minecraft.dropper": "dropper",
  "block.minecraft.white_terracotta": "white bakedclay",
  "block.minecraft.orange_terracotta": "yellowred bakedclay",
  "block.minecraft.magenta_terracotta": "bawsered bakedclay",
  "block.minecraft.light_blue_terracotta": "light hewen bakedclay",
  "block.minecraft.yellow_terracotta": "yellow bakedclay",
  "block.minecraft.lime_terracotta": "light green bakedclay",
  "block.minecraft.pink_terracotta": "pink bakedclay",
  "block.minecraft.gray_terracotta": "gray bakedclay",
  "block.minecraft.light_gray_terracotta": "light gray bakedclay",
  "block.minecraft.cyan_terracotta": "hewengreen bakedclay",
  "block.minecraft.purple_terracotta": "bawse bakedclay",
  "block.minecraft.blue_terracotta": "hewen bakedclay",
  "block.minecraft.brown_terracotta": "brown bakedclay",
  "block.minecraft.green_terracotta": "green bakedclay",
  "block.minecraft.red_terracotta": "red bakedclay",
  "block.minecraft.black_terracotta": "black bakedclay",
  "block.minecraft.barrier": "hinderer",
  "block.minecraft.iron_trapdoor": "iron trapdoor",
  "block.minecraft.hay_block": "hay bale",
  "block.minecraft.white_carpet": "white tappet",
  "block.minecraft.orange_carpet": "yellowred tappet",
  "block.minecraft.magenta_carpet": "bawsered tappet",
  "block.minecraft.light_blue_carpet": "light hewen tappet",
  "block.minecraft.yellow_carpet": "yellow tappet",
  "block.minecraft.lime_carpet": "light green tappet",
  "block.minecraft.pink_carpet": "pink tappet",
  "block.minecraft.gray_carpet": "gray tappet",
  "block.minecraft.light_gray_carpet": "light gray tappet",
  "block.minecraft.cyan_carpet": "hewengreen tappet",
  "block.minecraft.purple_carpet": "bawse tappet",
  "block.minecraft.blue_carpet": "hewen tappet",
  "block.minecraft.brown_carpet": "brown tappet",
  "block.minecraft.green_carpet": "green tappet",
  "block.minecraft.red_carpet": "red tappet",
  "block.minecraft.black_carpet": "black tappet",
  "block.minecraft.terracotta": "bakedclay",
  "block.minecraft.coal_block": "cleat of coal",
  "block.minecraft.packed_ice": "packed ice",
  "block.minecraft.acacia_stairs": "wattletree stairs",
  "block.minecraft.dark_oak_stairs": "dark oak stairs",
  "block.minecraft.slime_block": "slime block",
  "block.minecraft.grass_path": "grass path",
  "block.minecraft.sunflower": "sunbloom",
  "block.minecraft.lilac": "bawsebloom",
  "block.minecraft.rose_bush": "rose bush",
  "block.minecraft.peony": "smalltidebloom",
  "block.minecraft.tall_grass": "tall grass",
  "block.minecraft.large_fern": "tall fern",
  "block.minecraft.white_stained_glass": "white hued glass",
  "block.minecraft.orange_stained_glass": "yellowred hued glass",
  "block.minecraft.magenta_stained_glass": "bawsered hued glass",
  "block.minecraft.light_blue_stained_glass": "light hewen hued glass",
  "block.minecraft.yellow_stained_glass": "yellow hued glass",
  "block.minecraft.lime_stained_glass": "light green hued glass",
  "block.minecraft.pink_stained_glass": "pink hued glass",
  "block.minecraft.gray_stained_glass": "gray hued glass",
  "block.minecraft.light_gray_stained_glass": "light gray hued glass",
  "block.minecraft.cyan_stained_glass": "hewengreen hued glass",
  "block.minecraft.purple_stained_glass": "bawse hued glass",
  "block.minecraft.blue_stained_glass": "hewen hued glass",
  "block.minecraft.brown_stained_glass": "brown hued glass",
  "block.minecraft.green_stained_glass": "green hued glass",
  "block.minecraft.red_stained_glass": "red hued glass",
  "block.minecraft.black_stained_glass": "black hued glass",
  "block.minecraft.white_stained_glass_pane": "white hued glass window",
  "block.minecraft.orange_stained_glass_pane": "yellowred hued glass window",
  "block.minecraft.magenta_stained_glass_pane": "bawsered hued glass window",
  "block.minecraft.light_blue_stained_glass_pane": "light hewen hued glass window",
  "block.minecraft.yellow_stained_glass_pane": "yellow hued glass window",
  "block.minecraft.lime_stained_glass_pane": "light green hued glass window",
  "block.minecraft.pink_stained_glass_pane": "pink hued glass window",
  "block.minecraft.gray_stained_glass_pane": "gray hued glass window",
  "block.minecraft.light_gray_stained_glass_pane": "light gray hued glass window",
  "block.minecraft.cyan_stained_glass_pane": "hewengreen hued glass window",
  "block.minecraft.purple_stained_glass_pane": "bawse hued glass window",
  "block.minecraft.blue_stained_glass_pane": "hewen hued glass window",
  "block.minecraft.brown_stained_glass_pane": "brown hued glass window",
  "block.minecraft.green_stained_glass_pane": "green hued glass window",
  "block.minecraft.red_stained_glass_pane": "red hued glass window",
  "block.minecraft.black_stained_glass_pane": "black hued glass window",
  "block.minecraft.prismarine": "shimmereen",
  "block.minecraft.prismarine_bricks": "shimmereen stonestaves",
  "block.minecraft.dark_prismarine": "dark shimmereen",
  "block.minecraft.prismarine_stairs": "shimmereen stairs",
  "block.minecraft.prismarine_brick_stairs": "shimmereen stonestave stairs",
  "block.minecraft.dark_prismarine_stairs": "dark shimmereen stairs",
  "block.minecraft.sea_lantern": "sea lightvat",
  "block.minecraft.red_sandstone": "red sandstone",
  "block.minecraft.chiseled_red_sandstone": "graven red sandstone",
  "block.minecraft.cut_red_sandstone": "cut red sandstone",
  "block.minecraft.red_sandstone_stairs": "red sandstone stairs",
  "block.minecraft.repeating_command_block": "edlocking hest block",
  "block.minecraft.chain_command_block": "fettered hest block",
  "block.minecraft.magma_block": "moltenstone block",
  "block.minecraft.nether_wart_block": "nether wart block",
  "block.minecraft.warped_wart_block": "warped wart block",
  "block.minecraft.red_nether_bricks": "red nether bakestones",
  "block.minecraft.bone_block": "bone block",
  "block.minecraft.structure_void": "framework roomth",
  "block.minecraft.observer": "umbletend",
  "block.minecraft.shulker_box": "shulker crate",
  "block.minecraft.white_shulker_box": "white shulker crate",
  "block.minecraft.orange_shulker_box": "yellowred shulker crate",
  "block.minecraft.magenta_shulker_box": "bawsered shulker crate",
  "block.minecraft.light_blue_shulker_box": "light hewen shulker crate",
  "block.minecraft.yellow_shulker_box": "yellow shulker crate",
  "block.minecraft.lime_shulker_box": "light green shulker crate",
  "block.minecraft.pink_shulker_box": "pink shulker crate",
  "block.minecraft.gray_shulker_box": "gray shulker crate",
  "block.minecraft.light_gray_shulker_box": "light gray shulker crate",
  "block.minecraft.cyan_shulker_box": "hewengreen shulker crate",
  "block.minecraft.purple_shulker_box": "bawse shulker crate",
  "block.minecraft.blue_shulker_box": "hewen shulker crate",
  "block.minecraft.brown_shulker_box": "brown shulker crate",
  "block.minecraft.green_shulker_box": "green shulker crate",
  "block.minecraft.red_shulker_box": "red shulker crate",
  "block.minecraft.black_shulker_box": "black shulker crate",
  "block.minecraft.white_glazed_terracotta": "white glazed bakedclay",
  "block.minecraft.orange_glazed_terracotta": "yellowred glazed bakedclay",
  "block.minecraft.magenta_glazed_terracotta": "bawsered glazed bakedclay",
  "block.minecraft.light_blue_glazed_terracotta": "light hewen glazed bakedclay",
  "block.minecraft.yellow_glazed_terracotta": "yellow glazed bakedclay",
  "block.minecraft.lime_glazed_terracotta": "light green glazed bakedclay",
  "block.minecraft.pink_glazed_terracotta": "pink glazed bakedclay",
  "block.minecraft.gray_glazed_terracotta": "gray glazed bakedclay",
  "block.minecraft.light_gray_glazed_terracotta": "light gray glazed bakedclay",
  "block.minecraft.cyan_glazed_terracotta": "hewengreen glazed bakedclay",
  "block.minecraft.purple_glazed_terracotta": "bawse glazed bakedclay",
  "block.minecraft.blue_glazed_terracotta": "hewen glazed bakedclay",
  "block.minecraft.brown_glazed_terracotta": "brown glazed bakedclay",
  "block.minecraft.green_glazed_terracotta": "green glazed bakedclay",
  "block.minecraft.red_glazed_terracotta": "red glazed bakedclay",
  "block.minecraft.black_glazed_terracotta": "black glazed bakedclay",
  "block.minecraft.white_concrete": "white manstone",
  "block.minecraft.orange_concrete": "yellowred manstone",
  "block.minecraft.magenta_concrete": "bawsered manstone",
  "block.minecraft.light_blue_concrete": "light hewen manstone",
  "block.minecraft.yellow_concrete": "yellow manstone",
  "block.minecraft.lime_concrete": "light green manstone",
  "block.minecraft.pink_concrete": "pink manstone",
  "block.minecraft.gray_concrete": "gray manstone",
  "block.minecraft.light_gray_concrete": "light gray manstone",
  "block.minecraft.cyan_concrete": "hewengreen manstone",
  "block.minecraft.purple_concrete": "bawse manstone",
  "block.minecraft.blue_concrete": "hewen manstone",
  "block.minecraft.brown_concrete": "brown manstone",
  "block.minecraft.green_concrete": "green manstone",
  "block.minecraft.red_concrete": "red manstone",
  "block.minecraft.black_concrete": "black manstone",
  "block.minecraft.white_concrete_powder": "white manstone dust",
  "block.minecraft.orange_concrete_powder": "yellowred manstone dust",
  "block.minecraft.magenta_concrete_powder": "bawsered manstone dust",
  "block.minecraft.light_blue_concrete_powder": "light hewen manstone dust",
  "block.minecraft.yellow_concrete_powder": "yellow manstone dust",
  "block.minecraft.lime_concrete_powder": "light green manstone dust",
  "block.minecraft.pink_concrete_powder": "pink manstone dust",
  "block.minecraft.gray_concrete_powder": "gray manstone dust",
  "block.minecraft.light_gray_concrete_powder": "light gray manstone dust",
  "block.minecraft.cyan_concrete_powder": "hewengreen manstone dust",
  "block.minecraft.purple_concrete_powder": "bawse manstone dust",
  "block.minecraft.blue_concrete_powder": "hewen manstone dust",
  "block.minecraft.brown_concrete_powder": "brown manstone dust",
  "block.minecraft.green_concrete_powder": "green manstone dust",
  "block.minecraft.red_concrete_powder": "red manstone dust",
  "block.minecraft.black_concrete_powder": "black manstone dust",
  "block.minecraft.turtle_egg": "shellpad ey",
  "block.minecraft.dead_tube_coral_block": "dead reed limeshaft cleat",
  "block.minecraft.dead_brain_coral_block": "dead brain limeshaft block",
  "block.minecraft.dead_bubble_coral_block": "dead bubble limeshaft block",
  "block.minecraft.dead_fire_coral_block": "dead fire limeshaft block",
  "block.minecraft.dead_horn_coral_block": "dead horn limeshaft block",
  "block.minecraft.tube_coral_block": "reed limeshaft block",
  "block.minecraft.brain_coral_block": "brain limeshaft block",
  "block.minecraft.bubble_coral_block": "bubble limeshaft block",
  "block.minecraft.fire_coral_block": "fire limeshaft block",
  "block.minecraft.horn_coral_block": "horn limeshaft block",
  "block.minecraft.tube_coral": "reed limeshaft",
  "block.minecraft.brain_coral": "brain limeshaft",
  "block.minecraft.bubble_coral": "bubble limeshaft",
  "block.minecraft.fire_coral": "fire limeshaft",
  "block.minecraft.horn_coral": "horn limeshaft",
  "block.minecraft.dead_brain_coral": "dead brain limeshaft",
  "block.minecraft.dead_bubble_coral": "dead bubble limeshaft",
  "block.minecraft.dead_fire_coral": "dead fire limeshaft",
  "block.minecraft.dead_horn_coral": "dead horn limeshaft",
  "block.minecraft.dead_tube_coral": "dead reed limeshaft",
  "block.minecraft.tube_coral_fan": "reed limeshaft waffer",
  "block.minecraft.brain_coral_fan": "brain limeshaft waffer",
  "block.minecraft.bubble_coral_fan": "bubble limeshaft waffer",
  "block.minecraft.fire_coral_fan": "fire limeshaft waffer",
  "block.minecraft.horn_coral_fan": "horn limeshaft waffer",
  "block.minecraft.dead_tube_coral_fan": "dead reed limeshaft waffer",
  "block.minecraft.dead_brain_coral_fan": "dead brain limeshaft waffer",
  "block.minecraft.dead_bubble_coral_fan": "dead bubble limeshaft waffer",
  "block.minecraft.dead_fire_coral_fan": "dead fire limeshaft waffer",
  "block.minecraft.dead_horn_coral_fan": "dead horn limeshaft waffer",
  "block.minecraft.blue_ice": "hewen ice",
  "block.minecraft.conduit": "ithelode",
  "block.minecraft.polished_granite_stairs": "smoothed moorstone stairs",
  "block.minecraft.smooth_red_sandstone_stairs": "smooth red sandstone stairs",
  "block.minecraft.mossy_stone_brick_stairs": "mossy stonestave stairs",
  "block.minecraft.polished_diorite_stairs": "smooth markfieldstone stairs",
  "block.minecraft.mossy_cobblestone_stairs": "mossy cobblestone stairs",
  "block.minecraft.end_stone_brick_stairs": "end stonestave stairs",
  "block.minecraft.stone_stairs": "stone stairs",
  "block.minecraft.smooth_sandstone_stairs": "smooth sandstone stairs",
  "block.minecraft.smooth_quartz_stairs": "smooth hardstone stairs",
  "block.minecraft.granite_stairs": "moorstone stairs",
  "block.minecraft.andesite_stairs": "andestone stairs",
  "block.minecraft.red_nether_brick_stairs": "red nether bakestone stairs",
  "block.minecraft.polished_andesite_stairs": "smooth andestone stairs",
  "block.minecraft.diorite_stairs": "markfieldstone stairs",
  "block.minecraft.polished_granite_slab": "smoothed moorstone slab",
  "block.minecraft.smooth_red_sandstone_slab": "smooth red sandstone slab",
  "block.minecraft.mossy_stone_brick_slab": "mossy stonestave slab",
  "block.minecraft.polished_diorite_slab": "smooth markfieldstone slab",
  "block.minecraft.mossy_cobblestone_slab": "mossy cobblestone slab",
  "block.minecraft.end_stone_brick_slab": "end stonestave slab",
  "block.minecraft.smooth_sandstone_slab": "smooth sandstone slab",
  "block.minecraft.smooth_quartz_slab": "smooth hardstone slab",
  "block.minecraft.granite_slab": "moorstone slab",
  "block.minecraft.andesite_slab": "andestone slab",
  "block.minecraft.red_nether_brick_slab": "red nether bakestone slab",
  "block.minecraft.polished_andesite_slab": "smooth andestone slab",
  "block.minecraft.diorite_slab": "markfieldstone slab",
  "block.minecraft.scaffolding": "framescape",
  "block.minecraft.iron_door": "iron door",
  "block.minecraft.oak_door": "oak door",
  "block.minecraft.spruce_door": "harttartree door",
  "block.minecraft.birch_door": "birch door",
  "block.minecraft.jungle_door": "rainwold door",
  "block.minecraft.acacia_door": "wattletree door",
  "block.minecraft.dark_oak_door": "dark oak door",
  "block.minecraft.crimson_door": "base door",
  "block.minecraft.warped_door": "warped door",
  "block.minecraft.repeater": "redstone edlocker",
  "block.minecraft.comparator": "redstone likener",
  "block.minecraft.structure_block": "framework block",
  "block.minecraft.jigsaw": "inlocking block",
  "item.minecraft.turtle_helmet": "shellpad shell□□when on head:□+2 hirsting",
  "item.minecraft.scute": "shellpad shield",
  "item.minecraft.iron_shovel": "iron shovel□□when in main hand:□+3.5 strike harm□-3 strike speed",
  "item.minecraft.iron_pickaxe": "iron pike□□when in main hand:□+3 strike harm□-2.8 strike speed",
  "item.minecraft.iron_axe": "iron axe□□when in main hand:□+8 strike harm□-3.1 strike speed",
  "item.minecraft.flint_and_steel": "flint and steel",
  "item.minecraft.apple": "apple",
  "item.minecraft.bow": "bow",
  "item.minecraft.arrow": "arrow",
  "item.minecraft.coal": "coal",
  "item.minecraft.charcoal": "charcoal",
  "item.minecraft.diamond": "hardhirst",
  "item.minecraft.iron_ingot": "iron ingot",
  "item.minecraft.gold_ingot": "gold ingot",
  "item.minecraft.netherite_ingot": "netherstone ingot",
  "item.minecraft.netherite_scrap": "netherstone offcut",
  "item.minecraft.iron_sword": "iron sword□□when in main hand:□+5 strike harm□-2.4 strike speed",
  "item.minecraft.wooden_sword": "wood sword□□when in main hand:□+3 strike harm□-2.4 strike speed",
  "item.minecraft.wooden_shovel": "wood shovel□□when in main hand:□+1.5 strike harm□-3 strike speed",
  "item.minecraft.wooden_pickaxe": "wooden pike□□when in main hand:□+1 strike harm□-2.8 strike speed",
  "item.minecraft.wooden_axe": "wooden axe□□when in main hand:□+6 strike harm□-3.2 strike speed",
  "item.minecraft.stone_sword": "stone sword□□when in main hand:□+4 strike harm□-2.4 strike speed",
  "item.minecraft.stone_shovel": "stone shovel□□when in main hand:□+2.5 strike harm□-3 strike speed",
  "item.minecraft.stone_pickaxe": "stone pike□□when in main hand:□+2 strike harm□-2.8 strike speed",
  "item.minecraft.stone_axe": "stone axe□□when in main hand:□+8 strike harm□-3.2 strike speed",
  "item.minecraft.diamond_sword": "hardhirst sword□□when in main hand:□+6 strike harm□-2.4 strike speed",
  "item.minecraft.diamond_shovel": "hardhirst shovel□□when in main hand:□+4.5 strike harm□-3 strike speed",
  "item.minecraft.diamond_pickaxe": "hardhirst pike□□when in main hand:□+4 strike harm□-2.8 strike speed",
  "item.minecraft.diamond_axe": "hardhirst axe□□when in main hand:□+8 strike harm□-3 strike speed",
  "item.minecraft.stick": "stick",
  "item.minecraft.bowl": "bowl",
  "item.minecraft.mushroom_stew": "toadstool broth",
  "item.minecraft.golden_sword": "golden sword□□when in main hand:□+3 strike harm□-2.4 strike speed",
  "item.minecraft.golden_shovel": "golden shovel□□when in main hand:□+1.5 strike harm□-3 strike speed",
  "item.minecraft.golden_pickaxe": "golden pike□□when in main hand:□+1 strike harm□-2.8 strike speed",
  "item.minecraft.golden_axe": "golden axe□□when in main hand:□+6 strike harm□-3 strike speed",
  "item.minecraft.netherite_sword": "netherstone sword□□when in main hand:□+7 strike harm□-2.4 strike speed",
  "item.minecraft.netherite_shovel": "netherstone shovel□□when in main hand:□+5.5 strike harm□-3 strike speed",
  "item.minecraft.netherite_pickaxe": "netherstone pike□□when in main hand:□+5 strike harm□-2.8 strike speed",
  "item.minecraft.netherite_axe": "netherstone axe□□when in main hand:□+9 strike harm□-3 strike speed",
  "item.minecraft.string": "string",
  "item.minecraft.feather": "feather",
  "item.minecraft.gunpowder": "gundust",
  "item.minecraft.wooden_hoe": "wooden hoe□□when in main hand:□-3 strike speed",
  "item.minecraft.stone_hoe": "stone hoe□□when in main hand:□-2 strike speed",
  "item.minecraft.iron_hoe": "iron hoe□□when in main hand:□-1 strike speed",
  "item.minecraft.diamond_hoe": "hardhirst hoe□□when in main hand:",
  "item.minecraft.golden_hoe": "golden hoe□□when in main hand:□-3 strike speed",
  "item.minecraft.netherite_hoe": "netherstone hoe□□when in main hand:",
  "item.minecraft.wheat_seeds": "wheat seeds",
  "item.minecraft.wheat": "wheat",
  "item.minecraft.bread": "bread",
  "item.minecraft.leather_helmet": "leather hat□□when on head:□+1 hirsting",
  "item.minecraft.leather_chestplate": "leather shirt□□when on body:□+3 hirsting",
  "item.minecraft.leather_leggings": "leather breeches□□when on legs:□+2 hirsting",
  "item.minecraft.leather_boots": "leather shoes□□when on feet:□+1 hirsting",
  "item.minecraft.chainmail_helmet": "mesh helm□□when on head:□+2 hirsting",
  "item.minecraft.chainmail_chestplate": "mesh chestshield□□when on body:□+5 hirsting",
  "item.minecraft.chainmail_leggings": "mesh leggings□□when on legs:□+4 hirsting",
  "item.minecraft.chainmail_boots": "mesh shoes□□when on feet:□+1 hirsting",
  "item.minecraft.iron_helmet": "iron helm□□when on head:□+2 hirsting",
  "item.minecraft.iron_chestplate": "iron chestshield□□when on body:□+6 hirsting",
  "item.minecraft.iron_leggings": "iron leggings□□when on legs:□+5 hirsting",
  "item.minecraft.iron_boots": "iron shoes□□when on feet:□+2 hirsting",
  "item.minecraft.diamond_helmet": "hardhirst helm□□when on head:□+3 hirsting□+2 hirsting toughness",
  "item.minecraft.diamond_chestplate": "hardhirst chestshield□□when on body:□+8 hirsting□+2 hirsting toughness",
  "item.minecraft.diamond_leggings": "hardhirst leggings□□when on legs:□+6 hirsting□+2 hirsting toughness",
  "item.minecraft.diamond_boots": "hardhirst shoes□□when on feet:□+3 hirsting□+2 hirsting toughness",
  "item.minecraft.golden_helmet": "golden helm□□when on head:□+2 hirsting",
  "item.minecraft.golden_chestplate": "golden chestshield□□when on body:□+5 hirsting",
  "item.minecraft.golden_leggings": "golden leggings□□when on legs:□+3 hirsting",
  "item.minecraft.golden_boots": "golden shoes□□when on feet:□+1 hirsting",
  "item.minecraft.netherite_helmet": "netherstone helm□□when on head:□+3 hirsting□+3 hirsting toughness□+1 knockback withstanding",
  "item.minecraft.netherite_chestplate": "netherstone chestshield□□when on body:□+8 hirsting□+3 hirsting toughness□+1 knockback withstanding",
  "item.minecraft.netherite_leggings": "netherstone leggings□□when on legs:□+6 hirsting□+3 hirsting toughness□+1 knockback withstanding",
  "item.minecraft.netherite_boots": "netherstone shoes□□when on feet:□+3 hirsting□+3 hirsting toughness□+1 knockback withstanding",
  "item.minecraft.flint": "flint",
  "item.minecraft.porkchop": "raw pigmeat",
  "item.minecraft.cooked_porkchop": "cooked pigmeat",
  "item.minecraft.painting": "tivering",
  "item.minecraft.golden_apple": "golden apple",
  "item.minecraft.enchanted_golden_apple": "galed golden apple",
  "block.minecraft.oak_sign": "oak tokenboard",
  "block.minecraft.spruce_sign": "harttartree tokenboard",
  "block.minecraft.birch_sign": "birch tokenboard",
  "block.minecraft.jungle_sign": "rainwold tokenboard",
  "block.minecraft.acacia_sign": "wattletree tokenboard",
  "block.minecraft.dark_oak_sign": "dark oak tokenboard",
  "block.minecraft.crimson_sign": "base tokenboard",
  "block.minecraft.warped_sign": "warped tokenboard",
  "item.minecraft.bucket": "buck",
  "item.minecraft.water_bucket": "water buck",
  "item.minecraft.lava_bucket": "moltenstone buck",
  "item.minecraft.minecart": "delvewain",
  "item.minecraft.saddle": "saddle",
  "item.minecraft.redstone": "redstone dust",
  "item.minecraft.snowball": "snowball",
  "item.minecraft.oak_boat": "oak boat",
  "item.minecraft.leather": "leather",
  "item.minecraft.milk_bucket": "milk buck",
  "item.minecraft.pufferfish_bucket": "buck of pufferfish",
  "item.minecraft.salmon_bucket": "buck of lax",
  "item.minecraft.cod_bucket": "buck of cod",
  "item.minecraft.tropical_fish_bucket": "buck of southsea fish",
  "item.minecraft.brick": "bakestone",
  "item.minecraft.clay_ball": "clay ball",
  "block.minecraft.dried_kelp_block": "dried ash seaweed bale",
  "item.minecraft.paper": "bookfell",
  "item.minecraft.book": "book",
  "item.minecraft.slime_ball": "slimeball",
  "item.minecraft.chest_minecart": "delvewain with chest",
  "item.minecraft.furnace_minecart": "delvewain with oven",
  "item.minecraft.egg": "ey",
  "item.minecraft.compass": "northfinder",
  "item.minecraft.fishing_rod": "fishing rod",
  "item.minecraft.clock": "watch",
  "item.minecraft.glowstone_dust": "glowstone dust",
  "item.minecraft.cod": "raw cod",
  "item.minecraft.salmon": "raw lax",
  "item.minecraft.tropical_fish": "southsea fish",
  "item.minecraft.pufferfish": "pufferfish",
  "item.minecraft.cooked_cod": "cooked cod",
  "item.minecraft.cooked_salmon": "cooked lax",
  "item.minecraft.ink_sac": "dye sack",
  "item.minecraft.red_dye": "red dye",
  "item.minecraft.green_dye": "green dye",
  "item.minecraft.cocoa_beans": "muckbeans",
  "item.minecraft.lapis_lazuli": "hewenstone",
  "item.minecraft.purple_dye": "bawse dye",
  "item.minecraft.cyan_dye": "hewengreen dye",
  "item.minecraft.light_gray_dye": "light gray dye",
  "item.minecraft.gray_dye": "gray dye",
  "item.minecraft.pink_dye": "pink dye",
  "item.minecraft.lime_dye": "light green dye",
  "item.minecraft.yellow_dye": "yellow dye",
  "item.minecraft.light_blue_dye": "light hewen dye",
  "item.minecraft.magenta_dye": "bawsered dye",
  "item.minecraft.orange_dye": "yellowred dye",
  "item.minecraft.bone_meal": "bone meal",
  "item.minecraft.blue_dye": "hewen dye",
  "item.minecraft.brown_dye": "brown dye",
  "item.minecraft.black_dye": "black dye",
  "item.minecraft.white_dye": "white dye",
  "item.minecraft.bone": "bone",
  "item.minecraft.sugar": "sweetstuff",
  "block.minecraft.cake": "sweetbake",
  "block.minecraft.white_bed": "white bed",
  "block.minecraft.orange_bed": "yellowred bed",
  "block.minecraft.magenta_bed": "bawsered bed",
  "block.minecraft.light_blue_bed": "light hewen bed",
  "block.minecraft.yellow_bed": "yellow bed",
  "block.minecraft.lime_bed": "light green bed",
  "block.minecraft.pink_bed": "pink bed",
  "block.minecraft.gray_bed": "gray bed",
  "block.minecraft.light_gray_bed": "light gray bed",
  "block.minecraft.cyan_bed": "hewengreen bed",
  "block.minecraft.purple_bed": "bawse bed",
  "block.minecraft.blue_bed": "hewen bed",
  "block.minecraft.brown_bed": "brown bed",
  "block.minecraft.green_bed": "green bed",
  "block.minecraft.red_bed": "red bed",
  "block.minecraft.black_bed": "black bed",
  "item.minecraft.cookie": "small sweetbake",
  "item.minecraft.filled_map": "map□#0",
  "item.minecraft.shears": "shears",
  "item.minecraft.melon_slice": "entapple sliver",
  "item.minecraft.dried_kelp": "dried ash seaweed",
  "item.minecraft.pumpkin_seeds": "harvestovet seeds",
  "item.minecraft.melon_seeds": "entapple seeds",
  "item.minecraft.beef": "raw steak",
  "item.minecraft.cooked_beef": "cooked steak",
  "item.minecraft.chicken": "raw chicken",
  "item.minecraft.cooked_chicken": "cooked chicken",
  "item.minecraft.rotten_flesh": "rotten flesh",
  "item.minecraft.ender_pearl": "ender seahirst",
  "item.minecraft.blaze_rod": "blaze rod",
  "item.minecraft.ghast_tear": "ghast tear",
  "item.minecraft.gold_nugget": "gold lumpling",
  "item.minecraft.nether_wart": "nether wart",
  "item.minecraft.potion": "uncraftbere lib□no rines",
  "item.minecraft.glass_bottle": "glass flask",
  "item.minecraft.spider_eye": "spider eye",
  "item.minecraft.fermented_spider_eye": "rotten spider eye",
  "item.minecraft.blaze_powder": "blaze dust",
  "item.minecraft.magma_cream": "moltenstone ream",
  "block.minecraft.brewing_stand": "brewing stand",
  "block.minecraft.cauldron": "ironcrock",
  "item.minecraft.ender_eye": "eye of ender",
  "item.minecraft.glistering_melon_slice": "glistering entapple sliver",
  "item.minecraft.bat_spawn_egg": "fluttershrew making ey",
  "item.minecraft.bee_spawn_egg": "bee making ey",
  "item.minecraft.blaze_spawn_egg": "blaze making ey",
  "item.minecraft.cat_spawn_egg": "cat making ey",
  "item.minecraft.cave_spider_spawn_egg": "hollow spider making ey",
  "item.minecraft.chicken_spawn_egg": "chicken making ey",
  "item.minecraft.cod_spawn_egg": "cod making ey",
  "item.minecraft.cow_spawn_egg": "cow making ey",
  "item.minecraft.creeper_spawn_egg": "creeper making ey",
  "item.minecraft.dolphin_spawn_egg": "tumbler making ey",
  "item.minecraft.donkey_spawn_egg": "easle making ey",
  "item.minecraft.drowned_spawn_egg": "waterfilled walker making ey",
  "item.minecraft.elder_guardian_spawn_egg": "elder ward making ey",
  "item.minecraft.enderman_spawn_egg": "enderman making ey",
  "item.minecraft.endermite_spawn_egg": "endermite making ey",
  "item.minecraft.evoker_spawn_egg": "awakener making ey",
  "item.minecraft.fox_spawn_egg": "fox making ey",
  "item.minecraft.ghast_spawn_egg": "ghast making ey",
  "item.minecraft.guardian_spawn_egg": "ward making ey",
  "item.minecraft.hoglin_spawn_egg": "borkle making ey",
  "item.minecraft.horse_spawn_egg": "horse making ey",
  "item.minecraft.husk_spawn_egg": "husk making ey",
  "item.minecraft.llama_spawn_egg": "drylandersheep making ey",
  "item.minecraft.magma_cube_spawn_egg": "moltenstone slime making ey",
  "item.minecraft.mooshroom_spawn_egg": "moostool making ey",
  "item.minecraft.mule_spawn_egg": "easlehorse making ey",
  "item.minecraft.ocelot_spawn_egg": "rathlee cat making ey",
  "item.minecraft.panda_spawn_egg": "catbear making ey",
  "item.minecraft.parrot_spawn_egg": "bleefowl making ey",
  "item.minecraft.phantom_spawn_egg": "nightghost making ey",
  "item.minecraft.pig_spawn_egg": "pig making ey",
  "item.minecraft.piglin_spawn_egg": "pigman making ey",
  "item.minecraft.pillager_spawn_egg": "reaver making ey",
  "item.minecraft.polar_bear_spawn_egg": "icebear making ey",
  "item.minecraft.pufferfish_spawn_egg": "pufferfish making ey",
  "item.minecraft.rabbit_spawn_egg": "hare making ey",
  "item.minecraft.ravager_spawn_egg": "render making ey",
  "item.minecraft.salmon_spawn_egg": "lax making ey",
  "item.minecraft.sheep_spawn_egg": "sheep making ey",
  "item.minecraft.shulker_spawn_egg": "shulker making ey",
  "item.minecraft.silverfish_spawn_egg": "silverfish making ey",
  "item.minecraft.skeleton_spawn_egg": "boneset making ey",
  "item.minecraft.skeleton_horse_spawn_egg": "boneset horse making ey",
  "item.minecraft.slime_spawn_egg": "slime making ey",
  "item.minecraft.spider_spawn_egg": "spider making ey",
  "item.minecraft.squid_spawn_egg": "dye fish making ey",
  "item.minecraft.stray_spawn_egg": "drifter making ey",
  "item.minecraft.strider_spawn_egg": "strider making ey",
  "item.minecraft.trader_llama_spawn_egg": "chapman drylandersheep making ey",
  "item.minecraft.tropical_fish_spawn_egg": "southsea fish making ey",
  "item.minecraft.turtle_spawn_egg": "shellpad making ey",
  "item.minecraft.vex_spawn_egg": "nettler making ey",
  "item.minecraft.villager_spawn_egg": "thorpsman making ey",
  "item.minecraft.vindicator_spawn_egg": "whitewasher making ey",
  "item.minecraft.wandering_trader_spawn_egg": "wandering chapman making ey",
  "item.minecraft.witch_spawn_egg": "witch making ey",
  "item.minecraft.wither_skeleton_spawn_egg": "wither bonset making ey",
  "item.minecraft.wolf_spawn_egg": "wolf making ey",
  "item.minecraft.zoglin_spawn_egg": "lorcle making ey",
  "item.minecraft.zombie_spawn_egg": "undead walker making ey",
  "item.minecraft.zombie_horse_spawn_egg": "undead horse making ey",
  "item.minecraft.zombie_villager_spawn_egg": "undead thorpsman making ey",
  "item.minecraft.zombified_piglin_spawn_egg": "undead pigman making ey",
  "item.minecraft.experience_bottle": "flask o' galdering",
  "item.minecraft.fire_charge": "fire dint",
  "item.minecraft.writable_book": "book and quill",
  "item.minecraft.written_book": "written book",
  "item.minecraft.emerald": "greenhirst",
  "item.minecraft.item_frame": "thing frame",
  "block.minecraft.flower_pot": "bloom pot",
  "item.minecraft.carrot": "yellowred more",
  "item.minecraft.potato": "earthapple",
  "item.minecraft.baked_potato": "baked earthapple",
  "item.minecraft.poisonous_potato": "attery earthapple",
  "item.minecraft.map": "empty map",
  "item.minecraft.golden_carrot": "golden more",
  "block.minecraft.skeleton_skull": "boneset headbone",
  "block.minecraft.wither_skeleton_skull": "wither boneset headbone",
  "block.minecraft.player_head": "player head",
  "block.minecraft.zombie_head": "undead walker head",
  "block.minecraft.creeper_head": "creeper head",
  "block.minecraft.dragon_head": "wyrm head",
  "item.minecraft.carrot_on_a_stick": "more on a stick",
  "item.minecraft.warped_fungus_on_a_stick": "warped fieldswamb on a stick",
  "item.minecraft.nether_star": "nether star",
  "item.minecraft.pumpkin_pie": "harvestovet bake",
  "item.minecraft.firework_rocket": "firework",
  "item.minecraft.firework_star": "firework star",
  "item.minecraft.enchanted_book": "galed book",
  "item.minecraft.nether_brick": "nether bakestone",
  "item.minecraft.quartz": "nether hardstone",
  "item.minecraft.tnt_minecart": "delvewain with blastkeg",
  "item.minecraft.hopper_minecart": "delvewain with hopper",
  "item.minecraft.prismarine_shard": "shimmereen shard",
  "item.minecraft.prismarine_crystals": "shimmereen hirsts",
  "item.minecraft.rabbit": "raw hare",
  "item.minecraft.cooked_rabbit": "cooked hare",
  "item.minecraft.rabbit_stew": "hare broth",
  "item.minecraft.rabbit_foot": "hare's foot",
  "item.minecraft.rabbit_hide": "hare hide",
  "item.minecraft.armor_stand": "hirsting stand",
  "item.minecraft.iron_horse_armor": "iron horse hirsting",
  "item.minecraft.golden_horse_armor": "golden horse hirsting",
  "item.minecraft.diamond_horse_armor": "hardhirst horse hirsting",
  "item.minecraft.leather_horse_armor": "leather horse hirsting",
  "item.minecraft.lead": "lead",
  "item.minecraft.name_tag": "nametag",
  "item.minecraft.command_block_minecart": "delvewain with hest aframer",
  "item.minecraft.mutton": "raw sheep",
  "item.minecraft.cooked_mutton": "cooked sheep",
  "block.minecraft.white_banner": "white streamer",
  "block.minecraft.orange_banner": "yellowred streamer",
  "block.minecraft.magenta_banner": "bawsered streamer",
  "block.minecraft.light_blue_banner": "light hewen streamer",
  "block.minecraft.yellow_banner": "yellow streamer",
  "block.minecraft.lime_banner": "light green streamer",
  "block.minecraft.pink_banner": "pink streamer",
  "block.minecraft.gray_banner": "gray streamer",
  "block.minecraft.light_gray_banner": "light gray streamer",
  "block.minecraft.cyan_banner": "hewengreen streamer",
  "block.minecraft.purple_banner": "bawse streamer",
  "block.minecraft.blue_banner": "hewen streamer",
  "block.minecraft.brown_banner": "brown streamer",
  "block.minecraft.green_banner": "green streamer",
  "block.minecraft.red_banner": "red streamer",
  "block.minecraft.black_banner": "black streamer",
  "item.minecraft.end_crystal": "end hirst",
  "item.minecraft.chorus_fruit": "stalfruit",
  "item.minecraft.popped_chorus_fruit": "popped stalfruit",
  "item.minecraft.beetroot": "red more",
  "item.minecraft.beetroot_seeds": "red more seeds",
  "item.minecraft.beetroot_soup": "red more broth",
  "item.minecraft.dragon_breath": "wyrm's breath",
  "item.minecraft.splash_potion": "splash uncraftbere lib□no rines",
  "item.minecraft.spectral_arrow": "ghostly arrow",
  "item.minecraft.tipped_arrow": "uncraftbere tipped arrow□no rines",
  "item.minecraft.lingering_potion": "lingering uncraftbere lib□no rines",
  "item.minecraft.shield": "shield",
  "item.minecraft.elytra": "enderwings",
  "item.minecraft.spruce_boat": "harttartree boat",
  "item.minecraft.birch_boat": "birch boat",
  "item.minecraft.jungle_boat": "rainwold boat",
  "item.minecraft.acacia_boat": "wattletree boat",
  "item.minecraft.dark_oak_boat": "dark oak boat",
  "item.minecraft.totem_of_undying": "token of undying",
  "item.minecraft.shulker_shell": "shulker shell",
  "item.minecraft.iron_nugget": "iron lumpling",
  "item.minecraft.knowledge_book": "knowledge book",
  "item.minecraft.debug_stick": "unbug stick",
  "item.minecraft.music_disc_13": "song dish□c418 - 13",
  "item.minecraft.music_disc_cat": "song dish□c418 - cat",
  "item.minecraft.music_disc_blocks": "song dish□c418 - blocks",
  "item.minecraft.music_disc_chirp": "song dish□c418 - chirp",
  "item.minecraft.music_disc_far": "song dish□c418 - far",
  "item.minecraft.music_disc_mall": "song dish□c418 - shop",
  "item.minecraft.music_disc_mellohi": "song dish□c418 - mellohi",
  "item.minecraft.music_disc_stal": "song dish□c418 - stal",
  "item.minecraft.music_disc_strad": "song dish□c418 - strad",
  "item.minecraft.music_disc_ward": "song dish□c418 - ward",
  "item.minecraft.music_disc_11": "song dish□c418 - 11",
  "item.minecraft.music_disc_wait": "song dish□c418 - wait",
  "item.minecraft.music_disc_pigstep": "song dish□lena raine - pigstep",
  "item.minecraft.trident": "leister□□when in main hand:□+8 strike harm□-2.9 strike speed",
  "item.minecraft.phantom_membrane": "nightghost hame",
  "item.minecraft.nautilus_shell": "sailorfish shell",
  "item.minecraft.heart_of_the_sea": "heart of the sea",
  "item.minecraft.crossbow": "roodbow",
  "item.minecraft.suspicious_stew": "wary broth",
  "block.minecraft.loom": "loom",
  "item.minecraft.flower_banner_pattern": "streamer twill□bloom shape",
  "item.minecraft.creeper_banner_pattern": "streamer twill□creeper shape",
  "item.minecraft.skull_banner_pattern": "streamer twill□headbone shape",
  "item.minecraft.mojang_banner_pattern": "streamer twill□thing",
  "item.minecraft.globe_banner_pattern": "streamer twill□world",
  "item.minecraft.piglin_banner_pattern": "streamer twill□pignose",
  "block.minecraft.composter": "bonemealer",
  "block.minecraft.barrel": "coop",
  "block.minecraft.smoker": "smoker",
  "block.minecraft.blast_furnace": "blast oven",
  "block.minecraft.cartography_table": "mapmaking bench",
  "block.minecraft.fletching_table": "arrowsmithing bench",
  "block.minecraft.grindstone": "grindstone",
  "block.minecraft.lectern": "reading stand",
  "block.minecraft.smithing_table": "smithing bench",
  "block.minecraft.stonecutter": "stonecutter",
  "block.minecraft.bell": "bell",
  "block.minecraft.lantern": "lightvat",
  "block.minecraft.soul_lantern": "soul lightvat",
  "item.minecraft.sweet_berries": "sweet berries",
  "block.minecraft.campfire": "haltfire",
  "block.minecraft.soul_campfire": "soul haltfire",
  "block.minecraft.shroomlight": "swamblight",
  "item.minecraft.honeycomb": "honeycomb",
  "block.minecraft.bee_nest": "bee nest",
  "block.minecraft.beehive": "beehive",
  "item.minecraft.honey_bottle": "honey flask",
  "block.minecraft.honey_block": "honey block",
  "block.minecraft.honeycomb_block": "honeycomb cleat",
  "block.minecraft.lodestone": "lodestone",
  "block.minecraft.netherite_block": "cleat of netherstone",
  "block.minecraft.ancient_debris": "fern dross",
  "block.minecraft.target": "markle",
  "block.minecraft.crying_obsidian": "weeping ravenglass",
  "block.minecraft.blackstone": "blackstone",
  "block.minecraft.blackstone_slab": "blackstone slab",
  "block.minecraft.blackstone_stairs": "blackstone stairs",
  "block.minecraft.gilded_blackstone": "gilded blackstone",
  "block.minecraft.polished_blackstone": "smooth blackstone",
  "block.minecraft.polished_blackstone_slab": "smooth blackstone slab",
  "block.minecraft.polished_blackstone_stairs": "smooth blackstone stairs",
  "block.minecraft.chiseled_polished_blackstone": "graven smooth blackstone",
  "block.minecraft.polished_blackstone_bricks": "smooth blackstone stonestaves",
  "block.minecraft.polished_blackstone_brick_slab": "smooth blackstone stonestave slab",
  "block.minecraft.polished_blackstone_brick_stairs": "smooth blackstone stonestave stairs",
  "block.minecraft.cracked_polished_blackstone_bricks": "cracked smooth blackstone stonestaves",
  "block.minecraft.respawn_anchor": "edstart holder",
}
export const enp = items; 
